<template>
  <div>
    <!-- dekstop -->
    <div class="d-none d-sm-block">
      <b-row>
        <b-col>
          <span style="font-size: 22px; font-weight: 600;">Price Detail</span>
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <b-row class="center-base between px-3" v-for="(x, i) in price_detail" :key="i">
        <b-col cols="3">
          <span style="font-size: 18px;">{{ x.label }}</span>
        </b-col>
        <b-col cols="5" class="text-right">
          <span v-if="x.amountIDR" style="font-size: 18px;">
            IDR {{ x.amountIDR }}
            <!-- <i v-if="x.amountEUR" style="font-size: 16px;">(EUR {{ x.amountEUR }})</i> -->
          </span>
          <span v-else>
            -
          </span>
        </b-col>
      </b-row>

      <b-row class="center-base between px-3 mt-3">
        <b-col cols="3">
          <span style="font-size: 20px;">{{ total_detail.label }}</span>
        </b-col>
        <b-col cols="5" class="text-right">
          <span style="font-size: 20px;">
            IDR {{ total_detail.amountIDR }}
            <!-- <i v-if="total_detail.amountEUR" style="font-size: 18px;">(EUR {{ total_detail.amountEUR }})</i> -->
          </span>
        </b-col>
      </b-row>

      <b-row class="mt-2 px-3">
        <b-col>
          <!-- <i>* EUR to IDR Exchange Rate: Rp. {{ toMoney(payment.euridrrate) }}</i> -->
        </b-col>
      </b-row>

      <!-- future development -->
      <!-- <b-row class="mt-4 mx-3 p-3" style="background-color: #dddddd; color: #233c7c; font-size: 18px; font-weight: 900; border-radius: 5px;">
        <b-col>
          Discount Code
        </b-col>
        <b-col class="text-right">
          SGJMSHORE
        </b-col>
      </b-row> -->
    </div>

    <!-- mobile -->
    <div class="d-block d-sm-none">
      <b-row>
        <b-col>
          <span style="font-size: 20px; font-weight: 600;">Price Detail</span>
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <b-row class="center-base between px-3" v-for="(x, i) in price_detail" :key="i">
        <b-col cols="4" class="p-0">
          <span style="font-size: 16px;">{{ x.label }}</span>
        </b-col>
        <b-col cols="6" class="p-0 text-right">
          <span v-if="x.amountIDR" style="font-size: 16px;">
            IDR {{ x.amountIDR }}
            <br>
            <!-- <i v-if="x.amountEUR" style="font-size: 12px;">(EUR {{ x.amountEUR }})</i> -->
          </span>
          <span v-else>
            -
          </span>
        </b-col>
      </b-row>

      <b-row class="center-base between px-3 mt-3">
        <b-col cols="4" class="p-0">
          <span style="font-size: 18px;">{{ total_detail.label }}</span>
        </b-col>
        <b-col cols="6" class="p-0 text-right">
          <span style="font-size: 18px;">
            IDR {{ total_detail.amountIDR }}
            <br>
            <!-- <i v-if="total_detail.amountEUR" style="font-size: 12px;">(EUR {{ total_detail.amountEUR }})</i> -->
          </span>
        </b-col>
      </b-row>

      <b-row class="mt-2 px-3">
        <b-col class="p-0" style="font-size: 12px;">
          <!-- <i>* EUR to IDR Exchange Rate: Rp. {{ toMoney(payment.euridrrate) }}</i> -->
        </b-col>
      </b-row>

      <!-- future development -->
      <!-- <b-row class="mt-4 mx-3 p-3" style="background-color: #dddddd; color: #233c7c; font-size: 18px; font-weight: 900; border-radius: 5px;">
        <b-col>
          Discount Code
        </b-col>
        <b-col class="text-right">
          SGJMSHORE
        </b-col>
      </b-row> -->
    </div>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Pay_PriceDetail',
  props: ['payment', 'price_detail', 'total_detail'],
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    toMoney: function (int) {
      if (int) return int.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-item {
  border-bottom: 2px solid #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/Pay/PriceDetail/PriceDetail.vue